import { motion } from "framer-motion";

export const Marquee = ({ text = "PREMIUM FINANCIAL SERVICES", className = "" }) => {
  const items = Array.from({ length: 4 });
  return (
    <div
      className={`relative w-full overflow-hidden border-y border-[#E4E4E7] bg-white py-6 sm:py-8 ${className}`}
      data-testid="editorial-marquee"
      aria-hidden="true"
    >
      <motion.div
        className="marquee-track"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration: 28, ease: "linear", repeat: Infinity }}
      >
        {items.map((_, i) => (
          <span
            key={i}
            className="mx-8 text-[9vw] font-bold uppercase leading-none tracking-tighter text-transparent"
            style={{
              WebkitTextStroke: "1px #d4d4d8",
            }}
          >
            {text} <span className="brand-text" style={{ WebkitTextStroke: "0" }}>&#8226;</span>
          </span>
        ))}
      </motion.div>
    </div>
  );
};

export default Marquee;
